import {Pipe, PipeTransform} from '@angular/core';
import * as _ from 'lodash';
@Pipe({
  name: 'orderBy',
  standalone:true
})
export class OrderByPipe implements PipeTransform {
  transform<T>(array: T[], args?: any): T[] {
    return _.sortBy(array, [args]) as T[];
  }
}
